// API
import { apiFetch } from '../../app/apiFetch';

/**
 * @function fetchSession
 * Returns a single session's data
 *
 * @param {number} userId Unique identifer for user
 * @param {number} sessionId Unique identifer for session
 *
 * @return {object} Session
 */
export function fetchSession(sessionId: number) {
    const endpoint = `/v1/session/enter`;
    const body = JSON.stringify({
        sess: sessionId,
    });

    return apiFetch('POST', endpoint, body);
}

/**
 * @function pushBingoClaim
 * Submits a bingo claim on a single pattern
 *
 * @param {number} gameId Unique identifier for game
 * @param {number} cards List of unique identifiers for each card
 * @param {number} patternId Unique identifier for pattern matched
 *
 * @return {any}
 */
export function pushBingoClaim(
    gameId: number,
    cards: number[],
    patternId: number,
) {
    const endpoint = `/v1/game/claim`;
    const body = JSON.stringify({
        currentGameId: gameId,
        cards: cards,
        patternId: patternId,
    });

    return apiFetch('POST', endpoint, body);
}
